<template>
  <div class="main-wrapper authendication-pages">
    <div class="content blur-ellipses">
      <div class="container">
        <div class="row">
          <div
            class="col-md-6 col-lg-6 mx-auto vph-100 d-flex align-items-center"
          >
            <div class="forgot-password w-100">
              <header class="text-center forgot-head-title">
                <router-link to="/">
                  <img
                    style="max-width: 400px;"
                    src="@/assets/img/logo_red.png"
                    class="img-fluid"
                    alt="Logo"
                  />
                </router-link>
              </header>
              <div class="shadow-card">
                <h2>Quên mật khẩu</h2>
                <p>Nhập Email đã đăng ký</p>
                <!-- Login Form -->
                <Form
                  @submit="onSubmit"
                  :validation-schema="schema"
                  v-slot="{ errors }"
                >
                  <div class="form-group">
                    <div class="group-img">
                      <Field
                        :class="{ 'is-invalid': errors.email }"
                        type="text"
                        name="email"
                        class="form-control"
                        placeholder="Email"
                        required
                      />
                      <div class="invalid-feedback">
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center"
                  >
                    Gửi
                    <i class="feather-arrow-right-circle ms-2"></i>
                  </button>
                </Form>
                <!-- /Login Form -->
              </div>
              <div class="bottom-text text-center">
                <p>
                  Bạn đã nhớ mật khẩu?
                  <router-link to="/login">Đăng nhập!</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { Field, Form } from "vee-validate";
import * as Yup from "yup";

export default {
  components: {
    Form,
    Field,
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string()
        .required("Vui lòng nhập email")
        .email("Invalid email"),
    });

    const onSubmit = async (values) => {
      try {
        const response = await fetchWrapper.post(
          `${process.env.VUE_APP_SERVER_URL}/api/auth/forgot-password`,
          {
            email: values.email,
          }
        );

        if (response.ok) {
          alert("Email đã được gửi. Vui lòng kiểm tra hộp thư đến của bạn.");
        }
      } catch (error) {
        console.error("Error sending forgot email:", error);
        alert("Có lỗi xảy ra. Vui lòng thử lại sau.");
      }
    };

    return {
      schema,
      onSubmit,
    };
  },
};
</script>
